import "./styles/index.scss";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import store from "./context/index";
import { Auth0Provider } from "@auth0/auth0-react";
import "./i18n";
import App from "./App";
import "./services/axios-interceptor";

// .env values
const domain = process.env.REACT_APP_MAGIC_STAMP_AUTH0_DOMAIN;
const clientId = process.env.REACT_APP_MAGIC_STAMP_AUTH0_CLIENT_ID;

if (!domain || !clientId) {
  throw new Error("Missing Auth0 config in .env");
}

// React Query client setup
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 3,
      retryDelay: 2000,
    },
    mutations: {
      retry: 7,
      retryDelay: 2000,
    },
  },
});

const useCallback = process.env.REACT_APP_USE_CALLBACK === "true";
const redirectUri = window.location.origin + (useCallback ? "/callback" : "");

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Auth0Provider
    domain={process.env.REACT_APP_MAGIC_STAMP_AUTH0_DOMAIN}
    clientId={process.env.REACT_APP_MAGIC_STAMP_AUTH0_CLIENT_ID}
    authorizationParams={{
      // redirect_uri: window.location.origin + "/callback",
      redirect_uri: redirectUri,
      audience: process.env.REACT_APP_MAGIC_STAMP_AUTH0_AUDIENCE,
      scope: "openid",
    }}
    cacheLocation="localstorage"
    useRefreshTokens={false} // Match working code
  >
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </QueryClientProvider>
    </Provider>
  </Auth0Provider>
);
